import React from 'react';
import { useCurrencyRates } from '../hooks/use-currency-rates.js';
import CurrencyRatesPageView from './currency-rates-page-view.jsx';

function CurrencyRatesPageContainer() {
  const state = useCurrencyRates();
  return <CurrencyRatesPageView {...state} />;
}

export default CurrencyRatesPageContainer;
